import React from 'react';
import PropTypes from 'prop-types';

const Twitter = ({ color = '#000', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={21} fill="none" {...props}>
    <path
      stroke={color}
      strokeWidth={1.5}
      d="M14.693 19.284 1.626 2.484a.6.6 0 0 1 .474-.968h2.48a.6.6 0 0 1 .473.232l13.067 16.8a.6.6 0 0 1-.474.968h-2.48a.6.6 0 0 1-.473-.232Z"
    />
    <path stroke={color} strokeLinecap="round" strokeWidth={1.5} d="m17.873 1.516-16 18" />
  </svg>
);

Twitter.propTypes = {
  color: PropTypes.string
};

export default Twitter;
